import React from "react";
import { useTranslation } from "react-i18next";
import { CheckBox } from "@app/components/Common";
import { COLORS } from "@app/constants";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useWindowDimensions } from "@app/hooks";

const TpslCheckBox = ({ title, checked, setChecked, color }) => {
  const { width } = useWindowDimensions();
  const { textGray } = React.useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  const handleChange = () => {
    setChecked(!checked);
  };
  return (
    <CheckBox
      labelStyle={{ marginTop: 10, color: textGray }}
      inputStyle={{
        width: "20px",
        height: "13px",
        border: `1px solid ${checked ? color : COLORS.lightGray}`,
        background: checked ? color : "transparent",
      }}
      textStyle={{
        color: checked ? textGray : textGray,
        fontSize: width > 1400 ? 12 : 10,
      }}
      label={title}
      value={checked}
      onChange={handleChange}
    />
  );
};

export default TpslCheckBox;
